// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39Cyz","footer":"styles_footer__2J0Kr"};